import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Observable } from "rxjs";
import { imageType } from "src/app/domain/enums/imageType.enum";
import { IFileUploaderRow } from "src/app/domain/interfaces/home-maintenance";
import { SnackBarComponent } from "../snack-bar/snack-bar.component";
@Component({
	selector: "app-file-uploader",
	templateUrl: "./file-uploader.component.html",
	styleUrls: ["./file-uploader.component.scss"]
})
export class FileUploaderComponent implements OnInit, OnChanges {
	constructor(
		private cdr: ChangeDetectorRef,
		private snackBar: MatSnackBar
	) {}

	@Input() rowObject: IFileUploaderRow;
	@Input() fileForm: UntypedFormGroup;
	@Input() desktopPreviews: string[] = [];
	@Input() mobilePreviews: string[] = [];

	selectedDesktopFiles?: FileList;
	selectedMobileFiles?: FileList;
	imageInfos?: Observable<any>;
	rowFooterTextDesktop = "Máx: 600kb | Extensão: .jpg, jpeg e png | Dimensões máx: 1600 x 320 px";
	rowFooterTextMobile = "Máx: 100kb | Extensão: .jpg, jpeg e png | Dimensões máx: 430 x 500 px";

	ngOnChanges(changes: SimpleChanges): void {
		this.cdr.detectChanges();
	}

	ngOnInit(): void {
		this.fileForm.controls.mobileImageLink.valueChanges.subscribe(r => {
			this.rowObject.row.desktop.hasChanged = true;
			this.rowObject.row.mobile.hasChanged = true;
		});
	}

	selectFiles(event: any, type: number): void {
		if (type === imageType.desktop) {
			this.selectedDesktopFiles = event.target.files;

			if (this.selectedDesktopFiles?.[0]) {
				const reader = new FileReader();
				reader.onload = async (e: any) => {
					//checa o tamanho das imagens
					const imageSizes = await this.imageSize(e);
					const checkImageType = this.checkFileType(e.target.result);
					const checkImageReturn = this.checkFileSizeAndType(
						imageSizes.height,
						imageSizes.width,
						event.target.files[0].size,
						type,
						checkImageType
					);
					//caso o tamanho seja maior mostra o modal e para a função
					if (!checkImageReturn.validImage || !checkImageType) {
						this.snackBar.openFromComponent(SnackBarComponent, {
							data: checkImageReturn.errorMessage
						});
						return;
					}
					this.desktopPreviews = [];
					this.desktopPreviews.push(e.target.result);
					this.fileForm.controls.desktopImageByte.setValue(e.target.result);
					this.rowObject.row.desktop.hasChanged = true;
					this.rowObject.row.desktop.rowFooterText = this.selectedDesktopFiles[0].name;
				};
				reader.readAsDataURL(this.selectedDesktopFiles[0]);
			}
		} else {
			this.selectedMobileFiles = event.target.files;

			if (this.selectedMobileFiles?.[0]) {
				const reader = new FileReader();
				reader.onload = async (e: any) => {
					//checa o tamanho das imagens
					const imageSizes = await this.imageSize(e);
					const checkImageType = this.checkFileType(e.target.result);
					const checkImageReturn = this.checkFileSizeAndType(
						imageSizes.height,
						imageSizes.width,
						event.target.files[0].size,
						type,
						checkImageType
					);
					//caso o tamanho seja maior mostra o modal e para a função
					if (!checkImageReturn.validImage) {
						this.snackBar.openFromComponent(SnackBarComponent, {
							data: checkImageReturn.errorMessage
						});
						return;
					}
					this.mobilePreviews = [];
					this.mobilePreviews.push(e.target.result);
					this.fileForm.controls.mobileImageByte.setValue(e.target.result);
					this.rowObject.row.mobile.hasChanged = true;
					this.rowObject.row.mobile.rowFooterText = this.selectedMobileFiles[0].name;
				};
				reader.readAsDataURL(this.selectedMobileFiles[0]);
			}
		}
	}

	imageSize(img): Promise<any> {
		const promise = new Promise((resolve, reject) => {
			var image = new Image();
			image.src = img.target.result;

			image.onload = () => {
				var height = image.naturalHeight;
				var width = image.naturalWidth;
				resolve({ width, height });
			};
			image.onerror = reject;
		});

		return promise;
	}

	checkFileSizeAndType(height, width, size, type, acceptable): any {
		let validImage = true;
		var errorMessage = "";
		if (!acceptable) {
			validImage = false;
			errorMessage = "Extensão da imagem diferente de png, jpeg e jpg.";
			return { validImage: validImage, errorMessage: errorMessage };
		}
		if (type === imageType.desktop) {
			if (height > 320) {
				validImage = false;
				errorMessage = "Dimensão da imagem diferente de 1600 x 320px";
			}
			if (width > 1600) {
				validImage = false;
				errorMessage = "Dimensão da imagem diferente de 1600 x 320px.";
			}
			if (size > 614400) {
				validImage = false;
				errorMessage = "Tamanho da imagem superior a 600kb. Imagens com tamanhos inferiores serão aceitas.";
			}
		} else {
			if (height > 500) {
				validImage = false;
				errorMessage = "Dimensão da imagem diferente de 430 x 500px.";
			}
			if (width > 430) {
				validImage = false;
				errorMessage = "Dimensão da imagem diferente de 430 x 500px.";
			}
			if (size > 102400) {
				validImage = false;
				errorMessage = "Tamanho da imagem superior a 100kb. Imagens com tamanhos inferiores serão aceitas.";
			}
		}
		return { validImage: validImage, errorMessage: errorMessage };
	}

	checkFileType(file): boolean {
		const acceptableFileTypes = ["png", "jpeg", "jpg"];
		const fileType = file.substring("data:image/".length, file.indexOf(";base64"));
		const isFileAcceptable = acceptableFileTypes.indexOf(fileType) > -1;

		return isFileAcceptable;
	}

	deleteFiles(type): void {
		if (type === imageType.desktop) {
			this.desktopPreviews = [];
			this.fileForm.controls.desktopImageByte.setValue("");
			this.fileForm.controls.desktopImageLink.setValue("");
			this.rowObject.row.desktop.rowFooterText = this.rowFooterTextDesktop;
		} else {
			this.mobilePreviews = [];
			this.fileForm.controls.mobileImageByte.setValue("");
			this.fileForm.controls.mobileImageLink.setValue("");
			this.rowObject.row.mobile.rowFooterText = this.rowFooterTextMobile;
		}
	}

	deleteLink(): void {
		this.fileForm.controls.mobileImageLink.setValue("");
		this.fileForm.controls.desktopImageLink.setValue("");
	}
}
